import styled from '@emotion/styled'

export const Bold = styled.div`
  font-family: Satoshi;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
`
